import React from "react";
import SignUp from "../components/signup/signup";
import Navbar from "../components/homePage/navBar";

const SignUpPage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <SignUp />
    </div>
  );
};

export default SignUpPage;
